import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { formConstant } from '../../../../../../config';
import { cellPhoneValidatorNew, emailValidator } from '../../../../../core/helpers/helpers.function';
import { IAvailableTypes, IConstantItem } from '../../../../../core/models/available-types.interface';
import { ICountry } from '../../../../../core/models/country.interface';
import { ConstantService } from '../../../../../core/services/constant.service';
import { NotificationService } from '../../../../../core/services/notification.service';
import { UserService } from '../../../../../core/services/user.service';
import { ShipmentType } from '../../../../../shared/enums/shipment-type.enum';
import { ICarriersItem } from '../../../models/carrier.interface';
import { IService, ISubService, IVendor } from '../../../../shipment-price/models/shipment-price.interface';
import { ShipmentPriceService } from '../../../../shipment-price/services/shipment-price.service';

@Component({
    selector: 'eci-carrier-popup',
    templateUrl: './carrier-popup.component.html',
    styleUrls: ['./carrier-popup.component.scss']
})
export class CarrierPopupComponent implements OnInit {

    public isActive: boolean = false;
    public showLoader: boolean = false;
    public createMode: boolean = false;
    public vendor: IVendor;
    public form: FormGroup;
    public title = 'Carriers / Providers';
    public typeList = ['carrier', 'provider'];
    public nameMaxLength = formConstant.textFieldMaxLength120;

    public services: IService[] = [];
    public subServices: ISubService[] = [];
    public countries: ICountry[] = [];

    public searchCountry: FormControl = new FormControl('');
    public searchService: FormControl = new FormControl('');
    public searchSubService: FormControl = new FormControl('');

    info: ICarriersItem;
    isUpdate: boolean = false;

    availableTypes: IAvailableTypes;
    searchCarrierMode: FormControl = new FormControl('');

    private errorHandler = (err) => {
        this.notify.showError(err.error.message);
        this.showLoader = false;
    }

    public compareServices = (o1: any, o2: any) => {
        return o1.id === o2.id;
    }

    constructor(
        // private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<CarrierPopupComponent>,
        private shipmentPriceService: ShipmentPriceService,
        private notify: NotificationService,
        public userSvc: UserService,
        private constSvc: ConstantService
    ) {

    }

    ngOnInit(): void {
        this.constSvc.availableTypes.subscribe(data => {
            this.availableTypes = data;
        });
        this.form = this.initializeForm();

    }

    get availableCarrierType(): IConstantItem[] {
        if (!this.availableTypes) {
            return;
        }
        return this.availableTypes.OrderShipmentType.filter(el => el.id !== ShipmentType.Inland);
    }

    get model(): ICarriersItem {
        return this.form.value;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    public onSubmit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            this.notify.showError('Not all fields are filled');
            return;
        }

        if (!this.isUpdate) {
            this.save();
        } else {
            this.update();
        }
    }

    private save(): void {
        this.showLoader = true;
        const carrierProvider = this.model;
        carrierProvider.createdBy = this.userSvc.user.email;
        this.shipmentPriceService.create<ICarriersItem>('carriers', carrierProvider).subscribe(data => {
            this.notify.showSuccessMessage(`Carrier was created successfully`);
            this.dialogRef.close(data);
        }, this.errorHandler);
    }

    private update(): void {
        this.showLoader = true;
        this.shipmentPriceService.update<ICarriersItem>('carriers', this.info.id, this.model).subscribe(data => {
            this.notify.showSuccessMessage('Carrier updated succsessfully');
            this.dialogRef.close(this.form.value);
        }, this.errorHandler);
    }


    private initializeForm(): FormGroup {
        let countryIso2 = 'us';
        if (this.countries.length > 0 && this.info?.countryPhoneCode) {
            countryIso2 = this.getDialCode(this.info?.countryPhoneCode);
        }
        return new FormGroup({
            carrierId: new FormControl({disabled: true, value: this.info?.carrierId}),
            mode: new FormControl(this.info?.mode, [Validators.required]),
            type: new FormControl(this.info?.type, [Validators.required]),
            name: new FormControl(
                this.info?.name || '',
                [
                    Validators.required,
                    Validators.maxLength(this.nameMaxLength),
                ]),
            contactName: new FormControl(
                this.info?.contactName || '',
                [
                    Validators.maxLength(this.nameMaxLength),
                ]),
            countryPhoneCode: new FormControl(
                this.info?.countryPhoneCode || '1'),
            countryIso2: new FormControl(countryIso2),
            phoneNumber: new FormControl(this.info?.phoneNumber, [cellPhoneValidatorNew()]),
            email: new FormControl(
                this.info?.email || '', [
                    Validators.email,
                    emailValidator(),
                ]),
            countryId: new FormControl(this.info?.countryId),
            // services: new FormControl(this.info?.services, [Validators.required]),
            subServices: new FormControl(this.info?.subServices, [Validators.required]),
        });

    }

    public get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    private getDialCode(phoneCode): string {
        const country = this.countries?.find((c) => c.phoneCode === phoneCode);
        return country?.code.toLowerCase();
    }

    public getFlagClass(id): string {
        const country = this.countries?.find((c) => c.id === id);
        return `iti__${country?.code.toLowerCase()}`;
    }

    public getCountryNameByCode(id): string {
        return this.countries?.find((c) => c.id === id)?.name;
    }

    public hasErrors(error): void {
        if (!error && this.form.get('phoneNumber').value) {
            this.form?.controls.phoneNumber.setErrors({'incorrect': !error});
        } else {
            this.form?.controls.phoneNumber.setErrors(null);
        }
    }

    public onCountryChange(phoneCode): void {
        this.form?.controls?.countryIso2.setValue(phoneCode.iso2);
        this.form?.controls?.countryPhoneCode.setValue(`+${phoneCode.dialCode}`);
    }

}
